/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProgramNotificationDto
 */
export interface ProgramNotificationDto {
    /**
     * 
     * @type {string}
     * @memberof ProgramNotificationDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramNotificationDto
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramNotificationDto
     */
    message?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProgramNotificationDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramNotificationDto
     */
    read?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProgramNotificationDto
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramNotificationDto
     */
    milestoneId?: string;
}

/**
 * Check if a given object implements the ProgramNotificationDto interface.
 */
export function instanceOfProgramNotificationDto(value: object): value is ProgramNotificationDto {
    return true;
}

export function ProgramNotificationDtoFromJSON(json: any): ProgramNotificationDto {
    return ProgramNotificationDtoFromJSONTyped(json, false);
}

export function ProgramNotificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramNotificationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'message': json['message'] == null ? undefined : json['message'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'read': json['read'] == null ? undefined : json['read'],
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'milestoneId': json['milestoneId'] == null ? undefined : json['milestoneId'],
    };
}

export function ProgramNotificationDtoToJSON(json: any): ProgramNotificationDto {
    return ProgramNotificationDtoToJSONTyped(json, false);
}

export function ProgramNotificationDtoToJSONTyped(value?: ProgramNotificationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'message': value['message'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'read': value['read'],
        'initiativeId': value['initiativeId'],
        'milestoneId': value['milestoneId'],
    };
}

